import { Injectable }                        from '@angular/core';

import { FormData, Main, Type, Size, Step3, Step4, Step5 }       from './formData.model';
import { WorkflowService }                   from '../workflow/workflow.service';
import { STEPS }                             from '../workflow/workflow.model';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class FormDataService {

    private formData: FormData = new FormData();
    private isMainFormValid: boolean = false;
    private isTypeFormValid: boolean = false;
    private isSizeFormValid: boolean = false;
    private isStep3FormValid: boolean = false;
    private isStep4FormValid: boolean = false;
    private isStep5FormValid: boolean = false;
    public isLoading: boolean;
    public feedback: number;

    constructor(private workflowService: WorkflowService, private http: HttpClient) {
    }

    getMain(): Main {
        // Return the  data
        var main: Main = {
            type: this.formData.Immobilie
        };
        return main;
    }

    setMain(type: string) {
        // Update the data only when the  Form had been validated successfully
        this.isMainFormValid = true;
        this.formData.Immobilie = type;
        // Validate Personal Step in Workflow
        this.workflowService.validateStep(STEPS.index);
    }

    getType(): Type {
        // Return the  data
        var type: Type = {
            type: this.formData.Typ
        };
        return type;
    }

    setType(type: string) {
        // Update the data only when the Form had been validated successfully
        this.isTypeFormValid = true;
        this.formData.Typ = type;
        // Validate Step in Workflow
        this.workflowService.validateStep(STEPS.haus1);
    }

    getSize(): Size {
        // Return the data
        var size: Size = {
            livingspace: this.formData.Wohnflaeche,
            space: this.formData.Grundstücksflaeche,
            room: this.formData.Zimmeranzahl
        };
        return size;
    }

    setSize(data: Size) {
         // Update the data only when the Form had been validated successfully
         this.isSizeFormValid = true;
         this.formData.Wohnflaeche = data.livingspace;
         this.formData.Grundstücksflaeche = data.space;
         this.formData.Zimmeranzahl = data.room;
         // Validate Step in Workflow
        this.workflowService.validateStep(STEPS.haus2);
    }

    getStep3(): Step3 {
        // Return the data
        var step3: Step3 = {
            constructionyear: this.formData.Baujahr,
            constructioncondition: this.formData.Zustand
        };
        return step3;
    }

    setStep3(data: Step3) {
         // Update the data only when the Form had been validated successfully
         this.isStep3FormValid = true;
         this.formData.Baujahr = data.constructionyear;
         this.formData.Zustand = data.constructioncondition;
         // Validate Step in Workflow
        this.workflowService.validateStep(STEPS.haus3);
    }

    getStep4(): Step4 {
        
        // Return the data
        var step4: Step4 = {
            postalcode: this.formData.Postleitzahl,
            city: this.formData.Stadt,
            address: this.formData.Adresse,
            address2: this.formData.Adresszusatz,
            price: this.formData.Wertschätzung,
            placestring: this.formData.Placestring
        };
        return step4;
    }

    setStep4(data: Step4) {
         // Update the data only when the Form had been validated successfully
         this.isStep4FormValid = true;
         this.formData.Postleitzahl = data.postalcode;
         this.formData.Stadt = data.city;
         this.formData.Adresse = data.address;
         this.formData.Adresszusatz = data.address2;
         this.formData.Wertschätzung = data.price;
         this.formData.Placestring = data.placestring;
         // Validate Step in Workflow
        this.workflowService.validateStep(STEPS.haus4);
    }

    getStep5(): Step5 {
        
        // Return the data
        var step5: Step5 = {
            gender: this.formData.Anrede,
            firstname: this.formData.Vorname,
            lastname: this.formData.Nachname,
            email: this.formData.Email,
            phone: this.formData.Telefonnummer,
            birthyear: this.formData.Geburtsjahr,
            source: this.formData.Promotion
        };
        return step5;
    }

    setStep5(data: Step5) {
         // Update the data only when the Form had been validated successfully
         this.isStep5FormValid = true;
         this.formData.Anrede = data.gender;
         this.formData.Vorname = data.firstname;
         this.formData.Nachname = data.lastname;
         this.formData.Email = data.email;
         this.formData.Telefonnummer = data.phone;
         this.formData.Geburtsjahr = data.birthyear;
         this.formData.Promotion = data.source;
         // Validate Step in Workflow
        this.workflowService.validateStep(STEPS.final);
    }

    getFormData(): FormData {
        // Return the entire Form Data
        return this.formData;
    }

    resetFormData(): FormData {
        // Reset the workflow
        this.workflowService.resetSteps();
        // Return the form data after all this.* members had been reset
        this.formData.clear();
        this.isMainFormValid = false;
        return this.formData;
    }

    isFormValid() {
        // Return true if all forms had been validated successfully; otherwise, return false
        return this.isMainFormValid
    }

    postToDynamics365() {
        this.isLoading = true;
        this.http.post('../dynamics365middleware/middleware.php', this.formData ).subscribe(
            (err) => { console.log(err); this.isLoading = false; this.feedback = 500; },
            (success) => { console.log(success.status); this.isLoading = false; this.feedback = success.status; }
        )
    }
    
}